import { useContext } from 'react';
import { Icon } from '@iconify/react';
import { TextsContext } from 'context/textsContext';
import { TitleH2Component } from 'components/TitleH2Component';
import { ParagraphComponent } from 'components/ParagraphComponent';
import style from 'scss/table.module.scss';
import StyleBtn from 'scss/btn.module.scss';

/**
 * Pantalla de error cuando no se pudo cargar el plan a editar
 * (`GET /my-favorite-plans/:id` falló). Reusa el empty state de la tabla del
 * dashboard para mantener el mismo lenguaje visual.
 *
 * El retry recarga la página: además de repetir la petición, reinicia el
 * formulario por completo, que es lo que se quiere tras un fallo de carga.
 */
const FavoritePlanLoadError = () => {
    const { texts } = useContext(TextsContext);

    return (
        <div className={style.empty}>
            <Icon icon="mdi:file-document-alert-outline" className={style.emptyIcon} />

            <TitleH2Component styleGroup={`raleway fw_700 color_primary ${style.emptyTitle}`}>
                {texts?.favorite_plan_form_load_error_title ?? 'We couldn’t load this template'}
            </TitleH2Component>

            <ParagraphComponent styleGroup={`Poppins ${style.emptyText}`}>
                {texts?.favorite_plan_form_load_error_text
                    ?? 'Something went wrong while loading your favorite plan. Please try again.'}
            </ParagraphComponent>

            <button
                type="button"
                onClick={() => window.location.reload()}
                className={`Poppins fw_500 color_primary mt-4 ${StyleBtn.btn} ${StyleBtn.wpbtn}`}
            >
                {texts?.favorite_plan_form_load_error_retry ?? 'Retry'}
            </button>
        </div>
    );
};

export default FavoritePlanLoadError;
